// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "reactPlayerPreview" + "." + "23059b0642916d5ae3f9" + ".js";
};